import { apiService } from '@app/services/api-service';

export abstract class SubdomainApi {
  static async register(subdomain: string) {
    await apiService.post('/private/customer/subdomain/register', { subdomain });
  }
}
